import DeviceProvider from './Device';

export default DeviceProvider;
